import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function FinancingPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-338">
      <Header data-id="element-339" />

      <main className="flex-grow pt-32 pb-20" data-id="element-340">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-341">
          <div className="border-2 border-dashed border-red-400 bg-red-50 rounded-lg p-10" data-id="element-342">
            <p className="text-2xl font-black text-red-700 uppercase tracking-wide" data-id="element-343">
              DO NOT IMPORT THIS CONTENT!
            </p>
            <p className="mt-4 text-sm text-red-600" data-id="element-344">
              Use the embedded content from the existing Financing webpage.
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-345" />
    </div>;
}